export enum SearchActionsEnum {
  SEARCH_SET_SEARCH_STRING = 'SEARCH_SET_SEARCH_STRING',
  SEARCH_GET_RESULT_DATA = 'SEARCH_GET_RESULT_DATA',
  SEARCH_SET_RESULT_DATA = 'SEARCH_SET_RESULT_DATA',
  SEARCH_RESET_PAGE = 'SEARCH_RESET_PAGE',
  SEARCH_GET_RESULT_DATA_NEXT_PAGE = 'SEARCH_GET_RESULT_DATA_NEXT_PAGE',
  SEARCH_SET_FILTER = 'SEARCH_SET_FILTER',
  SEARCH_EXPORT_DATA = 'SEARCH_EXPORT_DATA',
  SEARCH_GET_FILTER_OPTIONS = 'SEARCH_GET_FILTER_OPTIONS',
  SEARCH_SET_FILTER_OPTIONS = 'SEARCH_SET_FILTER_OPTIONS',
  SEARCH_SET_ORDER = 'SEARCH_SET_ORDER',
}
